var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPush(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 66,
    viewBox: "0 0 50 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0791 6.12158H7.83145C4.75968 6.12158 2.26953 8.69594 2.26953 11.8716V57.8716C2.26953 61.0472 4.75968 63.6216 7.83145 63.6216H30.0791C33.1509 63.6216 35.641 61.0472 35.641 57.8716V11.8716C35.641 8.69594 33.1509 6.12158 30.0791 6.12158Z",
    stroke: "#407DBB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9531 52.1216H19.2448",
    stroke: "#407DBB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7414 25.3334C40.7414 26.3943 40.3199 27.4117 39.5698 28.1619C38.8196 28.912 37.8022 29.3334 36.7414 29.3334C35.6805 29.3334 34.6631 28.912 33.9129 28.1619C33.1628 27.4117 32.7414 26.3943 32.7414 25.3334M37.7027 6.67077L35.748 6.66677C31.2894 6.6561 27.4187 10.2788 27.388 14.6668V19.7201C27.388 20.7734 27.2547 21.8014 26.68 22.6774L26.2974 23.2614C25.7147 24.1468 26.3414 25.3334 27.388 25.3334H46.0947C47.1414 25.3334 47.7667 24.1468 47.1854 23.2614L46.8027 22.6774C46.2294 21.8014 46.0947 20.7721 46.0947 19.7188V14.6681C46.0414 10.2788 42.1614 6.68144 37.7027 6.67077V6.67077Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7414 2.66675C37.4486 2.66675 38.1269 2.9477 38.627 3.4478C39.1271 3.94789 39.408 4.62617 39.408 5.33341V6.66675H34.0747V5.33341C34.0747 4.62617 34.3557 3.94789 34.8558 3.4478C35.3559 2.9477 36.0341 2.66675 36.7414 2.66675Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0981 6.67077L35.2452 6.66677C31.0186 6.6561 27.3494 10.2788 27.3204 14.6668V19.7201C27.3204 20.7734 27.194 21.8014 26.6492 22.6774L26.2865 23.2614C25.7341 24.1468 26.3282 25.3334 27.3204 25.3334H45.0533C46.0455 25.3334 46.6383 24.1468 46.0872 23.2614L45.7245 22.6774C45.181 21.8014 45.0533 20.7721 45.0533 19.7188V14.6681C45.0028 10.2788 41.3247 6.68144 37.0981 6.67077V6.67077ZM39.9786 25.3334C39.9786 26.3943 39.5792 27.4117 38.8681 28.1619C38.157 28.912 37.1925 29.3334 36.1868 29.3334C35.1812 29.3334 34.2167 28.912 33.5056 28.1619C32.7945 27.4117 32.3951 26.3943 32.3951 25.3334",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9786 25.3334C39.9786 26.3943 39.5792 27.4117 38.8681 28.1619C38.157 28.912 37.1925 29.3334 36.1868 29.3334C35.1812 29.3334 34.2167 28.912 33.5056 28.1619C32.7945 27.4117 32.3951 26.3943 32.3951 25.3334M37.0981 6.67077L35.2452 6.66677C31.0186 6.6561 27.3494 10.2788 27.3204 14.6668V19.7201C27.3204 20.7734 27.194 21.8014 26.6492 22.6774L26.2865 23.2614C25.7341 24.1468 26.3282 25.3334 27.3204 25.3334H45.0533C46.0455 25.3334 46.6383 24.1468 46.0872 23.2614L45.7245 22.6774C45.181 21.8014 45.0533 20.7721 45.0533 19.7188V14.6681C45.0028 10.2788 41.3247 6.68144 37.0981 6.67077V6.67077Z",
    stroke: "#407DBB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7421 2.66675C37.4493 2.66675 38.1276 2.9477 38.6277 3.4478C39.1278 3.94789 39.4088 4.62617 39.4088 5.33341V6.66675H34.0754V5.33341C34.0754 4.62617 34.3564 3.94789 34.8565 3.4478C35.3566 2.9477 36.0349 2.66675 36.7421 2.66675Z",
    stroke: "#407DBB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPush);
export default __webpack_public_path__ + "static/media/push.6ab4c1eb8d11a34212e6efc6f99ea6d7.svg";
export { ForwardRef as ReactComponent };